// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@store/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

/* Store Custom Code - Start */
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";
/* Store Custom Code - End */

export type LinkVariantOption = DataOption<LinkPresentationProps>;
export interface LinkVariantOptionMapper {
    standard: LinkVariantOption;
    action: LinkVariantOption;
    // Store Custom Code
    underlined: LinkVariantOption;
}
export type LinkVariantOptions = DataOptions<LinkVariantOption> & LinkVariantOptionMapper;
export type LinkVariant = LiteralUnion<keyof LinkVariantOptionMapper>;

export const linkVariantOptions: LinkVariantOptions = {
    standard: { id: "standard", displayName: "Standard", isDefault: true },
    action: { id: "action", displayName: "Action", value: { css: linkActionStyles() } },
    /* Store Custom Code - Start */
    underlined: {
        id: "underlined",
        displayName: "Underlined",
        value: {
            css: css`
                ${linkActionStyles()}
                text-decoration: underline;
                text-underline-offset: ${pxToRem(8)};

                &:hover,
                &:active {
                    text-decoration: none;
                }
            `,
        },
    },
    /* Store Custom Code - End */
};

export type LinkVariantFieldValue = LinkVariant | undefined;
export interface LinkVariantFieldOptions {
    isChildDefinition?: boolean;
}

export const getLinkVariantFieldData = (value: LinkVariantFieldValue, options?: LinkVariantFieldOptions) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(linkVariantOptions, value);
};

export const getLinkVariantFieldDefinition = (name: string, options?: LinkVariantFieldOptions) => {
    const { isChildDefinition } = options || {};

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(linkVariantOptions),
        name,
        displayName: "Link Variant",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getLinkVariantField = (name: string, options?: LinkVariantFieldOptions) => {
    const parse = (value: LinkVariantFieldValue) => getLinkVariantFieldData(value, options);

    return {
        definition: getLinkVariantFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
    };
};

export default getLinkVariantField;
